var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var _raw;
import { resolveResourceRef } from "./resource-ref.js";
import { uniqBy, merge } from "lodash-es";
import { DefaultActivationValidator } from "./validator.js";
import { arrayToInstances } from "./utils/to-instances.js";
class ActivationStore {
  constructor(populator, validator = new DefaultActivationValidator()) {
    __privateAdd(this, _raw, void 0);
    __publicField(this, "populated");
    __publicField(this, "instances");
    __publicField(this, "eventListeners", /* @__PURE__ */ new Map());
    this.populator = populator;
    this.validator = validator;
  }
  get raw() {
    return __privateGet(this, _raw);
  }
  get items() {
    return this.instances;
  }
  async set(data) {
    const res = await resolveResourceRef(data);
    if (res == null || !Array.isArray(res)) {
      console.error("Result is not an array of activations", data, res);
      await this.setRaw([]);
    } else {
      await this.setRaw(res);
    }
  }
  async push(data) {
    const res = await resolveResourceRef(data);
    await this.setRaw([...this.raw ?? [], ...res ?? []]);
  }
  /**
   * Replace activations with specific sources with the given data.
   * @param data
   * @param sourcesToReplace
   */
  async replaceBySources(data, sourcesToReplace) {
    const itemsToKeep = sourcesToReplace != null ? (this.raw ?? []).filter((i) => i.source == null || !sourcesToReplace.includes(i.source)) : [];
    const newRaw = uniqBy([...data, ...itemsToKeep], "externalId");
    await this.setRaw(newRaw);
  }
  find(id, instanceId) {
    if (id == null)
      return;
    return this.items.find((i) => {
      return `${i.id}` === `${id}` && (instanceId == null || i.instance.id === instanceId);
    });
  }
  updateActivationInstance(id, instanceId, update = {}) {
    this.instances = this.instances.map((i) => {
      if (`${i.id}` === `${id}` && (instanceId == null || i.instance.id === instanceId)) {
        return merge({}, i, update);
      }
      return i;
    });
  }
  async setRaw(data) {
    __privateSet(this, _raw, data);
    await this.sync();
  }
  async sync() {
    const populated = await this.populator.populate(this.raw ?? []);
    this.populated = this.validator.validate(populated);
    const instances = arrayToInstances(this.populated);
    this.instances = instances;
    this.emit("change", instances);
  }
  emit(event, data) {
    const listeners = this.eventListeners.get(event);
    if (listeners != null) {
      listeners.forEach((listener) => {
        listener(data);
      });
    }
  }
  on(event, listener) {
    const listeners = this.eventListeners.get(event) ?? /* @__PURE__ */ new Set();
    listeners.add(listener);
    this.eventListeners.set(event, listeners);
  }
  off(event, listener) {
    const listeners = this.eventListeners.get(event);
    if (listeners != null) {
      listeners.delete(listener);
    }
  }
}
_raw = new WeakMap();
export {
  ActivationStore
};
